import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { withApollo } from 'react-apollo'
import { Tabs, Typography, Spin, Row, Col, Input, message, Form, Icon } from 'antd'
import { Queries, Mutations } from '../../../../graphql'
import Container from '../../../../components/user/Container'
import { pushAge } from '../../../../utils/formatdate'
import moment from 'moment'
import iconsFormLabel from '../../../../assets/images/icons/icon-formlabel.png'
import { Link } from 'react-router-dom'
import { appVersion, versionWeb, checkLinkURL } from '../../../../utils/auth'
import axiosAPI, { urlAttachFile } from "../../../../config/axiosAPI";

const { TabPane } = Tabs
const { Text, Title } = Typography

const newsDataProfile = '';

class ProFileList extends Component {
	state = {
		dataProfileSSO : [],
      phoneNumber: null,
		dataNewProfile : {},
		loaddingDataNews : false,
        tableList : [
            // {
            //     nameApp: "V TRC (ESS) ",
            //     desc: "เป็นเว็บไซต์สำหรับบุคคลากร ในการดูข้อมูลประกาศข่าวสาร และข้อมูลของบุคลากร รวมถึงอำนวยความสะดวกในการทำธุรการต่างๆ เช่น การลา หรือ เบิกสวัสดิการอื่นๆ"
            // },
            // {
            //     nameApp: "V TRC (Backoffice) ",
            //     desc: "ระบบสำหรับแอดมิน ธุรการสำนักงานหรือผู้ที่ได้รับมอบหมาย ในการจัดการการลา หรือ บันทึกการเบิก แทนบุคคลากร"
            // }
        ],
        listUserManual:[
            {
                name: "คู่มือการใช้งานกาชาดไอดี.pdf",
                link: "https://dititivelab.com/file/vtrc/คู่มือ SSO MVP2.pdf"
            },
            {
                name: "สื่อความกาชาดไอดี.pdf",
                link: "https://drive.google.com/file/d/1EXnDM27kOfJvWtdrDR5Zp_kdlPFmPfvC/view?usp=sharing"
            },
            {
               name: "Q&A.pdf",
               link: "https://dititivelab.com/file/vtrc/SSO%20Q&A.pdf"
           },
        ]
	}

	getInfoAuth = async () =>{
		axiosAPI.get(`${checkLinkURL()}config/get-info-auth`)
		.then(response => {
			console.log("response SSO : info-auth :", response.data.data)
			this.setState({
				dataProfileSSO: response.data.data,
            phoneNumber: response.data.data.phoneNumber[0],
            tableList: response.data.data.appList
			})
		}).catch(
			error => console.error(`Error: ${error}`)
		)
		// console.log("DataFetchAPI", DataFetchAPI)
	}

	async componentDidMount(){
        this.getInfoAuth()
		// await this.fetchProfile()
    }

	render() {
		const { history, location, match, form } = this.props
		const { loaddingDataNews, dataNewProfile, dataProfileSSO, tableList, phoneNumber} = this.state
        const { getFieldDecorator } = form
        // console.log('dataProfileSSO?.phoneNumber' , dataProfileSSO.phoneNumber)
		return (
			<Container match={match}>
				<div className="card-container" id="page-profile">
					<div className="px-5 py-4 card-bg-green" style={{borderRadius: "10px"}}>
                        <Row gutter={[16, 8]} style={{backgroundColor: "#fff", borderRadius: "10px"}} className='py-4'>
                            <Col md={20} offset={2} >
                                <Text style={{ color:"#D94339" }}>
                                    กาชาดไอดี
                                </Text>
                            </Col>
                            <Col md={10} offset={2}>
                                <Form.Item 
                  		            label={
                                        <>
                                            <b>ชื่อผู้ใช้งาน</b> 
                                        </>
                                    }
                                    labelAlign="left" 
                                    name="username" 
                                    style={{ marginBottom: '0' }}
                                >
                                    {getFieldDecorator('username', {
                                        initialValue: dataProfileSSO.username,
                                    })(
                                        <Input
                                            style={{ borderRadius: '100px' }}
                                            placeholder=""
                                            disabled
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={[16, 8]} style={{backgroundColor: "#fff", borderRadius: "10px"}} className='py-4 mt-4'>
                            <Col md={18} offset={2} >
                                <Text style={{ color:"#D94339" }}>
                                ช่องทางการรับ OTP
                                </Text>
                            </Col>
                            <Col md={5} offset={2}>
                                <Form.Item 
                  		            label={"ช่องทางรับ OTP"}
                                    labelAlign="left" 
                                    name="otp" 
                                    style={{ marginBottom: '0' }}
                                >
                                    {getFieldDecorator('otp', {
                                        initialValue: "SMS",
                                        rules: [{ required: true, message: '“กรุณาระบุชื่อผู้ใช้งาน”' }]
                                    })(
                                        <Input
                                            style={{ borderRadius: '100px' }}
                                            placeholder=""
                                            disabled
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col md={7}>
                                <Form.Item 
                  		            label={"หมายเลขโทรศัพท์"}
                                    labelAlign="left" 
                                    name="tel" 
                                    style={{ marginBottom: '0' }}
                                >
                                    {getFieldDecorator('tel', {
                                        initialValue: phoneNumber,
                                        rules: [{ required: true, message: '“กรุณาระบุชื่อผู้ใช้งาน”' }]
                                    })(
                                        <Input
                                            style={{ borderRadius: '100px' }}
                                            placeholder=""
                                            disabled
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={[16, 8]} style={{backgroundColor: "#fff", borderRadius: "10px"}} className='py-4 mt-5'>
                            <Col md={18} offset={2} >
                                <Text style={{ color:"#D94339" }}>
                                    สิทธิ์การเข้าใข้งานระบบต่าง ๆ ผ่านกาชาดไอดีของคุณ
                                </Text>
                            </Col>
                            <Col md={20} offset={2} className='mt-3'>
                                <table className="w-100">
                                    <tbody class="ant-table-tbody bd-0">
                                        <tr style={{ backgroundColor: "#4E6878", color:"#fff" }}>
                                            <th className='py-2' width="30%" style={{ textAlign: "center" }}>
                                                ระบบ
                                            </th>
                                            <th className='py-2' style={{ textAlign: "center" }}>
                                                คำอธิบายระบบ
                                            </th>
                                        </tr>
                                        {this.state.tableList?.map(
                                            (valuesLabel, keys) => {
                                                return (
                                                    <>
                                                        <tr>
                                                            <td>
                                                                { valuesLabel.appNameTH }
                                                            </td>
                                                            <td>
                                                                { valuesLabel.appDesc }
                                                            </td>
                                                        </tr>
                                                    </>
                                                );
                                            }
                                        )}
                                    </tbody>
                                </table>
                            </Col>
                        </Row>

                        <Row gutter={[16, 8]} style={{backgroundColor: "#fff", borderRadius: "10px"}} className='py-4 mt-5'>
                            <Col md={18} offset={2} >
                                <Text style={{ color:"#D94339" }}>
                                    คู่มือการใช้งาน
                                </Text>
                            </Col>
                            <Col md={20} offset={2} className='mt-3'>
                                <ul
                                    style={{ listStyle: "none" }}
                                >
                                    {this.state.listUserManual?.map(
                                        (valuesLabel, keys) => {
                                            return (
                                                <>
                                                    <li className='mb-2'>
                                                        <a href={ valuesLabel.link } target="_blank">
                                                            <Icon type="file-pdf" style={{ color:"#D94339" }} className='mr-2'/> 
                                                            { valuesLabel.name }
                                                        </a>
                                                    </li>
                                                </>
                                            );
                                        }
                                    )}
                                </ul>
                            </Col>
                        </Row>
					</div>
				</div>
			</Container>
		)
	}
}

ProFileList.defaultProps = {
	autoFocus: false
}

ProFileList.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedProFileList = Form.create()(ProFileList)
export default withApollo(WrappedProFileList)
